module.exports = "/assets/280286b2281bdec523514a4ff35a1a6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JQ.png
// module id = 2643
// module chunks = 0